var _excluded = ["makeDefault", "camera", "regress", "domElement", "enableDamping", "onChange", "onStart", "onEnd"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import _extends from '@babel/runtime/helpers/esm/extends';
import { useThree, useFrame } from '@react-three/fiber';
import * as React from 'react';
import { OrbitControls as OrbitControls$1 } from 'three-stdlib';
var OrbitControls = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var makeDefault = _ref.makeDefault,
      camera = _ref.camera,
      regress = _ref.regress,
      domElement = _ref.domElement,
      _ref$enableDamping = _ref.enableDamping,
      enableDamping = _ref$enableDamping === void 0 ? true : _ref$enableDamping,
      onChange = _ref.onChange,
      onStart = _ref.onStart,
      onEnd = _ref.onEnd,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var invalidate = useThree(function (state) {
    return state.invalidate;
  });
  var defaultCamera = useThree(function (state) {
    return state.camera;
  });
  var gl = useThree(function (state) {
    return state.gl;
  });
  var events = useThree(function (state) {
    return state.events;
  });
  var set = useThree(function (state) {
    return state.set;
  });
  var get = useThree(function (state) {
    return state.get;
  });
  var performance = useThree(function (state) {
    return state.performance;
  });
  var explCamera = camera || defaultCamera;
  var explDomElement = domElement || events.connected || gl.domElement;
  var controls = React.useMemo(function () {
    return new OrbitControls$1(explCamera);
  }, [explCamera]);
  useFrame(function () {
    if (controls.enabled) controls.update();
  });
  React.useEffect(function () {
    controls.connect(explDomElement);
    return function () {
      return void controls.dispose();
    };
  }, [explDomElement, regress, controls, invalidate]);
  React.useEffect(function () {
    var callback = function callback(e) {
      invalidate();
      if (regress) performance.regress();
      if (onChange) onChange(e);
    };

    controls.addEventListener('change', callback);
    if (onStart) controls.addEventListener('start', onStart);
    if (onEnd) controls.addEventListener('end', onEnd);
    return function () {
      if (onStart) controls.removeEventListener('start', onStart);
      if (onEnd) controls.removeEventListener('end', onEnd);
      controls.removeEventListener('change', callback);
    };
  }, [onChange, onStart, onEnd]);
  React.useEffect(function () {
    if (makeDefault) {
      // @ts-expect-error new in @react-three/fiber@7.0.5
      var old = get().controls; // @ts-expect-error new in @react-three/fiber@7.0.5

      set({
        controls: controls
      }); // @ts-expect-error new in @react-three/fiber@7.0.5

      return function () {
        return set({
          controls: old
        });
      };
    }
  }, [makeDefault, controls]);
  return /*#__PURE__*/React.createElement("primitive", _extends({
    ref: ref,
    object: controls,
    enableDamping: enableDamping
  }, restProps));
});
export { OrbitControls };